import React from "react";

const LS_KEY = "cookie_consent_v1";

export default function CookiePolicy() {
  const resetConsent = () => {
    localStorage.removeItem(LS_KEY);
    window.location.reload();
  };

  return (
    <section className="py-10 bg-white">
      <div className="max-w-[1100px] mx-auto px-4 prose prose-slate">
        <h1>Cookie-Richtlinie</h1>
        <p>
          Wir verwenden Cookies und ähnliche Technologien. Technisch
          erforderliche Cookies dienen der Bereitstellung der Seite. Für
          Statistik (Analytics) und Marketing setzen wir diese Technologien
          nur mit Ihrer Einwilligung (<a
            href="https://www.gesetze-im-internet.de/ttdsg/__25.html"
            target="_blank" rel="noreferrer">§ 25 TTDSG</a>).
        </p>

        <h2>Technisch erforderlich</h2>
        <p>Diese Cookies sind notwendig, um grundlegende Funktionen bereitzustellen (z. B. Seitennavigation, Formularschutz). Sie können nicht deaktiviert werden.</p>

        <h2>Statistik (Analytics)</h2>
        <p>Erfasst pseudonyme Nutzungsdaten zur Verbesserung der Website. Einsatz erfolgt nur mit Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Widerruf jederzeit möglich.</p>

        <h2>Marketing</h2>
        <p>Zur Anzeige relevanter Inhalte/Werbung – ebenfalls nur mit Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</p>

        <h2>Einwilligung verwalten</h2>
        <p>Sie können Ihre Einwilligung jederzeit widerrufen/neu setzen:</p>
        <button onClick={resetConsent} className="px-4 py-2 rounded-lg border">Einwilligung zurücksetzen</button>

        <h2>Rechtsgrundlagen & Leitfäden</h2>
        <ul>
          <li><a href="https://www.gesetze-im-internet.de/ttdsg/__25.html" target="_blank" rel="noreferrer">§ 25 TTDSG (Endgeräte-Infos/Cookies)</a></li>
          <li><a href="https://gdpr-info.eu/art-6-gdpr/" target="_blank" rel="noreferrer">Art. 6 DSGVO (Rechtsgrundlagen)</a></li>
          <li><a href="https://gdpr-info.eu/art-13-gdpr/" target="_blank" rel="noreferrer">Art. 13 DSGVO (Informationspflichten)</a></li>
          <li><a href="https://www.bfdi.bund.de/EN/Press/Press_Release/2019/26_WebtrackingEinwilligung.html" target="_blank" rel="noreferrer">BfDI: Web-Tracking nur mit Einwilligung</a></li>
        </ul>

        <p className="text-sm opacity-70">Stand: {new Date().toLocaleDateString()}</p>
      </div>
    </section>
  );
}
